import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

class AnchorMenu {
  constructor(el) {
    this.el = el;
    this.init = this.init.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.header = document.querySelector('[data-header]');
    this.init();
  }

  init() {
    this.el.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', this.onClick);
    });
    this.initScrollTrigger();

    /*window.addEventListener('scroll', () => {
      const scrollPosition = window.pageYOffset + this.el.offsetHeight;
      if (
        this.el.getBoundingClientRect().top +
          window.scrollY -
          this.el.offsetHeight <=
          scrollPosition &&
        this.el.getBoundingClientRect().top +
          window.scrollY +
          this.el.offsetHeight >
          scrollPosition
      ) {
        this.el.classList.add('anchor-menu--show');
      } else {
        this.el.classList.remove('anchor-menu--show');
      }
    });*/
  }

  onClick(e) {
    e.preventDefault();
    const { currentTarget } = e;
    const anchorMenuHeight = this.el.offsetHeight;
    const id = currentTarget.getAttribute('href');
    if (id === '#') return;
    const offsetTop = document.querySelector(id).offsetTop;

    const offsetPosition = offsetTop - anchorMenuHeight;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
      duration: 500,
    });
  }

  animateIndicator(el) {
    if (!el) {
      return;
    }
    const anchorWidth = el.offsetWidth;
    const anchorLeft = el.offsetLeft;
    const anchorBtnIndicator = this.el.querySelector(
      '[data-anchor-btn-indicator]'
    );

    gsap.to(anchorBtnIndicator, {
      duration: 0.5,
      width: anchorWidth,
      x: anchorLeft,
    });
  }

  getSections() {
    const anchorMenuItems = this.el.querySelectorAll('a[href^="#"]');
    return Array.from(anchorMenuItems)
      .map((anchor) => {
        const id = anchor.getAttribute('href');
        if (id === '#') return null;
        return document.querySelector(id);
      })
      .filter((value, id, self) => self.indexOf(value) === id);
  }

  initScrollTrigger() {
    const sections = this.getSections();
    if (sections.length > 0)
      ScrollTrigger.batch(sections, {
        start: 'top 40%',
        end: 'bottom 40%',
        onEnter: this.onEnter,
        onEnterBack: this.onEnter,
        scrub: true,
      });
  }

  onEnter(elements) {
    const el = elements[0];
    if (!el) return;
    const id = el.getAttribute('id');
    const active = this.el.querySelector('.active');
    const anchor = this.el.querySelector('[href="#' + id + '"]');
    if (active) {
      active.classList.remove('active');
    }
    anchor.classList.add('active');
    this.animateIndicator(anchor);
  }
}

export default AnchorMenu;
